class ProductDetails extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.product-details-toggle');
    this.content = this.querySelector('.product-details-content');
    
    if (this.button && this.content) {
      this.button.addEventListener('click', this.toggleDetails.bind(this));
    }
  }

  toggleDetails() {
    const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
    
    this.button.setAttribute('aria-expanded', !isExpanded);
    
    if (isExpanded) {
      this.content.setAttribute('hidden', '');
    } else {
      this.content.removeAttribute('hidden');
    }
  }
}

customElements.define('product-details', ProductDetails);